import React from 'react'
import findIndex from 'lodash/findIndex'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss'
import { PhotoType } from '../../store/commonTypes'
import { Attachment } from 'pm-js/src/types/pm'

interface Props {
    list: PhotoType[] | Attachment[]
    photo: PhotoType
}

SwiperCore.use([Navigation])

const SwiperUnrestricted: React.FunctionComponent<Props> = ({ list, photo }: Props) => {
    return (
        // @ts-ignore
        <Swiper navigation initialSlide={findIndex(list, photo)} className="mySwiper">
            {list.map((item) => (
                // @ts-ignore
                <SwiperSlide key={item.id || item.url}>
                    <img className="photo" src={item.url} alt="" />
                    {/*@ts-ignore*/}
                    {item.comments && <div className="description">{item.comments}</div>}
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default SwiperUnrestricted
